import { styled } from "@mui/material";
import { getThemeSpacing } from "../../../functions/util";

const PREFIX = "TermsOfUseStyles";
export const classes = {
  container: `${PREFIX}-container`,
  margin: `${PREFIX}-margin`,
  ol: `${PREFIX}-ol`
};

export const Div = styled("div")(({ theme }) => ({
  [`&.${classes.container}`]: {
    margin: getThemeSpacing(theme, 2)
  },
  [`& .${classes.margin}`]: {
    marginTop: getThemeSpacing(theme, 8)
  },
  [`& .${classes.ol}`]: {
    "& li": {
      marginTop: getThemeSpacing(theme, 2)
    }
  }
}));
